import React, { Component } from 'react'
// import { connect } from 'react-redux'
// import { translation } from '../../../utils/helpers'
import Label from '../label'
import Icon from '../icon'
import HelpIcon from '../helpIcon'
import '../elements.scss'
import './check.scss'
import { ElementIcons } from '../icons'
import { isiOS } from '../../../constants'
import { isTouchDevice } from '../../../utils/detect'

class Check extends Component {
  constructor (props) {
    super(props)
    this.state = {

    }
    this.onChange = this.onChange.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    let updateComp = false
    if (nextProps.id !== this.props.id) {
      updateComp = true
    }
    if (nextProps.name !== this.props.name) {
      updateComp = true
    }
    if (nextProps.value !== this.props.value) {
      updateComp = true
    }
    if (nextProps.onChange !== this.props.onChange) {
      if (this.props.onChange && nextProps.onChange) {
        if (this.props.onChange.toString() !== nextProps.onChange.toString()) {
          updateComp = true
        }
      } else {
        updateComp = true
      }
    }
    if (nextProps.checked !== this.props.checked) {
      updateComp = true
    }
    if (nextProps.labelText !== this.props.labelText) {
      updateComp = true
    }
    if (nextProps.size !== this.props.size) {
      updateComp = true
    }
    if (nextProps.style !== this.props.style) {
      updateComp = true
    }
    if (nextProps.helpText !== this.props.helpText) {
      updateComp = true
    }
    if (nextProps.labelAlignment !== this.props.labelAlignment) {
      updateComp = true
    }
    if (nextProps.onClick !== this.props.onClick) {
      if (this.props.onClick && nextProps.onClick) {
        if (this.props.onClick.toString() !== nextProps.onClick.toString()) {
          updateComp = true
        }
      } else {
        updateComp = true
      }
    }
    if (nextProps.disabled !== this.props.disabled) {
      updateComp = true
    }
    if (nextProps.readOnly !== this.props.readOnly) {
      updateComp = true
    }
    if (nextProps.required !== this.props.required) {
      updateComp = true
    }
    if (nextProps.width !== this.props.width) {
      updateComp = true
    }
    if (nextProps.spacing !== this.props.spacing) {
      updateComp = true
    }
    if (nextProps.simple !== this.props.simple) {
      updateComp = true
    }
    // console.log('ShouldUpdate? ', updateComp, 'THIS', this.props, 'NEXT', nextProps) //nextProps.onChange.toString() === this.props.onChange.toString(), nextProps.onChange.toString().length, this.props.onChange.toString().length,  nextProps.onChange.toString(), this.props.onChange.toString() )//nextProps, this.props)
    return updateComp
  }

  onChange (e) {
    // console.log('Check onChange triggered! ', e)
    if (this.props.onChange !== null) {
      this.props.onChange(e)
    }
  }

  onClick (e) {
    // console.log('Check onClick triggered! ', e)
    if (this.props.onClick !== null) {
      this.props.onClick(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  getSolidClass () {
    return ''
  }

  getBorderClass () {
    return ''
  }

  getWidthClass () {
    if (this.props.width === null) return ''
    let width = typeof this.props.width === 'number' ? width : parseInt(this.props.width)
    return ' cnt-w-' + width
  }

  getSpacingClass () {
    if (this.props.simple) return ''

    let spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing
    if (spacing === 0) return ''
    if (spacing < 0) return ' pg-my-default'
    return ' pg-my-' + spacing
  }

  getIconSize () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 's':
        return 's'
      case 'm':
      case 'l':
        return 'm'
    }
  }

  getStyle () {
    return 'element-check' + this.getSizeClass() + this.getSpacingClass() + this.getWidthClass() + this.getSolidClass() + this.getBorderClass()
  }

  getContainerStyle () {
    if (this.props.simple) return 'container'

    let containerStyles = 'container'

    switch (this.props.labelAlignment) {
      case 'r':
        containerStyles += ' label-right'
        break
      case 'l':
        containerStyles += ' label-left'
        break
    }

    if (this.props.size === 'l') {
      if (this.props.disabled) {
        containerStyles += ' container--disabled'
      } else if (this.props.checked) {
        containerStyles += ' container--checked'
      }
    }

    return containerStyles
  }

  render () {
    const { simple } = this.props
    const iconSize = this.getIconSize()
    let iosCustomNormal = ''
    let iosCustomHover = ''
    let isiPadPro = isTouchDevice() && /MacIntel/.test(navigator.platform)
    let iosDevice = isiOS || isiPadPro
    if (iosDevice) {
      iosCustomNormal = ' customIos-normal'
      iosCustomHover = ' customIos-hover'
    }
    return (
      <div className={this.getStyle()}>
        <div>
          <label onClick={(e) => e.stopPropagation()} className={this.getContainerStyle()}>
            {!simple && <Label>{this.props.labelText}</Label>}

            <input
              type='checkbox'
              id={this.props.id}
              name={this.props.name}
              value={this.props.value}
              onChange={this.onChange}
              onClick={this.onClick}
              checked={this.props.checked}
              // indeterminate={this.props.indeterminate}
              disabled={this.props.disabled}
              readOnly={this.props.readOnly}
              required={this.props.required}
            />

            {!this.props.disabled && !this.props.indeterminate && this.props.checked && <Icon icon={ElementIcons.Check_Selected} className='check-checked' icon2={ElementIcons.Check_Selected_Check} size={iconSize} injectSvg />}
            {!this.props.disabled && !this.props.indeterminate && !this.props.checked && <Icon icon={ElementIcons.Check_Normal} className={'check-normal' + iosCustomNormal} size={iconSize} injectSvg />}
            {this.props.disabled && !this.props.indeterminate && <Icon icon={ElementIcons.Check_Disabled} className='check-disabled' size={iconSize} injectSvg />}
            {this.props.disabled && !this.props.indeterminate && this.props.checked && <Icon icon={ElementIcons.Check_SelectedDisabled} className='check-checked-disabled' size={iconSize} injectSvg />}
            {!iosDevice && !this.props.disabled && !this.props.indeterminate && !this.props.checked && <Icon icon={ElementIcons.Check_Hover} className={'check-hover' + iosCustomHover} size={iconSize} injectSvg />}
            {!this.props.disabled && this.props.indeterminate && <Icon icon={ElementIcons.Check_IndeterminateSelected} className='check-indeterminate-selected' size={iconSize} injectSvg />}
            {this.props.disabled && this.props.indeterminate && <Icon icon={ElementIcons.Check_IndeterminateDisabled} className='check-indeterminate-disabled' size={iconSize} injectSvg />}
          </label>
        </div>

        {!simple && this.props.helpText && <HelpIcon helpText={this.props.helpText} />}
      </div>
    )
  }
}

Check.defaultProps = {
  size: 's',
  style: 'default',
  labelText: null,
  helpText: null,
  labelAlignment: 'r',
  onChange: null,
  onClick: null,
  value: false,
  checked: null,
  indeterminate: false,
  disabled: false,
  readOnly: false,
  required: false,
  width: null,
  spacing: -1,
  simple: false
}

export default Check



// WEBPACK FOOTER //
// ./src/app/shared/elements/check/index.js